import type { AppRoutes } from "@/infra/router";
import { getUrlWithLocale } from "@/infra/router/utils";
import { useIntl } from "@/infra/locale";
import type { CopyKeyCare } from "@akina/infra";
import { ExternalLink, TextLink, useLocaleStore } from "@akina/presentation";

type LegalExternalLinkProps = {
  route: AppRoutes;
  messageId: CopyKeyCare;
};

export function LegalExternalLink({ route, messageId }: Readonly<LegalExternalLinkProps>) {
  const { formatMessage } = useIntl();
  const { locale } = useLocaleStore();
  const label = formatMessage({ id: messageId });

  return (
    <ExternalLink href={getUrlWithLocale(route, locale)} title={label}>
      <TextLink size="base" className="whitespace-nowrap">
        {label}
      </TextLink>
    </ExternalLink>
  );
}
